export default [
  {
    path: '/executive-dashboard',
    name: 'executive-dashboard',
    component: () => import('@/views/pages/dashboard/ExecutiveDashboard.vue'),
    meta: {
      pageTitle: 'Executive Dashboard',
      hasPermission: 'VIEW_EXECUTIVE_DASHBOARD',
      skipFavorites: true,
      breadcrumb: [
        {
          text: 'Dashboard',
        },
        {
          text: 'Executive Dashboard',
          active: true,
        },
      ],
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/pages/dashboard/Index.vue'),
    meta: {
      pageTitle: 'Dashboard',
      // hasPermission: 'VIEW_BASIC_DASHBOARD',
      skipFavorites: true,
      breadcrumb: [
        {
          text: 'Dashboard',
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      pageTitle: 'Home',
      breadcrumb: [
        {
          text: 'Dashboard',
        },
        {
          text: 'Home',
          active: true,
        },
      ],
      skipFavorites: true,
    },
    component: () => import('@/views/pages/dashboard/LandingPage.vue'),
  },
  {
    path: '/pfi-dashboard',
    name: 'pfi-dashboard',
    meta: {
      pageTitle: 'PFI Dashboard',
      hasPermission: 'VIEW_PFI_DASHBOARD',
      breadcrumb: [
        {
          text: 'Dashboard',
        },
        {
          text: 'PFI Dashboard',
          active: true,
        },
      ],
      // skipFavorites: true,
    },
    component: () => import('@/views/pages/dashboard/PFIDashboard.vue'),
  },
  {
    path: '/admin-dashboard',
    name: 'admin-dashboard',
    meta: {
      pageTitle: 'Admin Dashboard',
      hasPermission: 'VIEW_ADMIN_APPROVALS',
      breadcrumb: [
        {
          text: 'Dashboard',
        },
        {
          text: 'Admin Dashboard',
          active: true,
        },
      ],
      skipFavorites: true,
    },
    component: () => import('@/views/pages/dashboard/AdminDashboard.vue'),
  },
]
